import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import Div from "@jumbo/shared/Div";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TableCell,
    Typography,
} from "@mui/material";
import useResponsive from "app/pages/useResponsive";
import { DateFormatter, formatIndianNumber } from "app/shared/ReuseComponents/DateFormatter";
import WorkflowApproverStatus from "app/shared/ReuseComponents/WorkflowApproverStatus";
import PropTypes from "prop-types";
import React from "react";
import { MdClose } from "react-icons/md";


const SettlementDocumentApproval = ({
    openViewRequest,
    setOpenViewRequest,
    requests,
    approvalStatus,
}) => {

    const WorkflowName = "Full and Final Settlement"

    return (
        <>
            <Dialog maxWidth="xl" fullWidth open={openViewRequest}>
                <DialogTitle
                    sx={{ display: "flex", justifyContent: "space-between", mb: -2 }}
                >
                    <Div sx={{ fontSize: "18px" }}>View Full and Final Settlement</Div>
                    <Div>
                        <IconButton onClick={() => setOpenViewRequest(false)}>
                            <MdClose />
                        </IconButton>
                    </Div>
                </DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Div sx={{ mt: 2, mb: 1 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <Grid container>
                                            <Grid item xs={4}>
                                                <Typography variant="h4">Name of Employee</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="h4">: {requests?.Employee_Name}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={4}>
                                                <Typography variant="h4">Department</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="h4">: {requests?.Department}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={4}>
                                                <Typography variant="h4">Resignation Date</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="h4">
                                                    : <DateFormatter date={requests?.Date_Of_Resignation} />
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={4}>
                                                <Typography variant="h4">Relieving Date</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="h4">
                                                    : <DateFormatter date={requests?.Releiving_Date} />
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Grid container>
                                            <Grid item xs={4}>
                                                <Typography variant="h4">Employee Code</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="h4">: {requests?.Employee_Id}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={4}>
                                                <Typography variant="h4">Reporting To</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="h4">: {requests?.Reporting_To}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={4}>
                                                <Typography variant="h4">Acceptance Date</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="h4">
                                                    : <DateFormatter date={requests?.Acceptance_Date} />
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Div>

                            <JumboScrollbar
                                autoHeight
                                autoHideTimeout={4000}
                                autoHeightMin={300}
                                autoHide
                                hideTracksWhenNotNeeded
                                id="no-more-tables"
                            >
                                <Table stickyHeader className="table">
                                    <TableHead className="table-head">
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell>Month</TableCell>
                                            <TableCell>Days</TableCell>
                                            <TableCell className="Amount_Fields">Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {requests?.Salary_Details?.salaryDetails && requests?.Salary_Details?.salaryDetails?.length > 0 ? (
                                            (() => {
                                                return (
                                                    <>
                                                        {requests?.Salary_Details?.salaryDetails?.map((data, index) => (
                                                            <React.Fragment key={index}>
                                                                <TableRow key={`earnings-${index}`}>
                                                                    <TableCell data-title="">Salary</TableCell>
                                                                    <TableCell data-title="Month">
                                                                        {data?.month || 'N/A'}
                                                                    </TableCell>
                                                                    <TableCell data-title="Days">{data?.days || 'N/A'}</TableCell>
                                                                    <TableCell data-title="Amount" className="Amount_Fields">
                                                                        {formatIndianNumber(data?.amount) || 0}
                                                                    </TableCell>
                                                                </TableRow>
                                                            </React.Fragment>
                                                        ))}

                                                        <TableRow>
                                                            <TableCell data-title="">Gratuity</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                                {formatIndianNumber(requests?.Salary_Details?.gratuity)}
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell data-title="">Leave Encashment</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                                {formatIndianNumber(requests?.Salary_Details?.leaveEncashment)}
                                                            </TableCell>
                                                        </TableRow>

                                                        {Object.entries(requests?.Salary_Details?.reimbursement || {}).length > 0 && (
                                                            <TableRow>
                                                                <TableCell data-title="" sx={{ fontWeight: 600 }}>Reimburshment</TableCell>
                                                                <TableCell data-title="Month"></TableCell>
                                                                <TableCell data-title="Days"></TableCell>
                                                                <TableCell data-title="Amount" className="Amount_Fields">
                                                                </TableCell>
                                                            </TableRow>
                                                        )}

                                                        {Object.entries(requests?.Salary_Details?.reimbursement || {}).map(([key, opt], index) => (
                                                            <TableRow key={index}>
                                                                <TableCell data-title="">{key}</TableCell>
                                                                <TableCell data-title="Month"></TableCell>
                                                                <TableCell data-title="Days"></TableCell>
                                                                <TableCell data-title="Amount" className="Amount_Fields">
                                                                    {formatIndianNumber(opt?.reimbursement)}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}

                                                        <TableRow>
                                                            <TableCell data-title="" sx={{ fontWeight: 600 }}>Total Earnings (A)</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                                {formatIndianNumber(requests?.Salary_Details?.totalEarnings)}
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell data-title="" sx={{ fontWeight: 600 }}>Provident Fund</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                                {formatIndianNumber(requests?.Salary_Details?.providentFund)}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell data-title="" sx={{ fontWeight: 600 }}>Professional Tax</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                                {formatIndianNumber(requests?.Salary_Details?.professionalTax)}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell data-title="" sx={{ fontWeight: 600 }}>ESI</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                                {formatIndianNumber(requests?.Salary_Details?.esi)}
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell data-title="">Income Tax(TDS)</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                                {formatIndianNumber(requests?.Salary_Details?.incomeTax)}
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell data-title="" sx={{ fontWeight: 600 }}>Total Deductions (B)</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                                {formatIndianNumber(requests?.Salary_Details?.totalDeductions || 0)}
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell data-title="" sx={{ fontWeight: 600 }}>Net Settlement Dues</TableCell>
                                                            <TableCell data-title="Month"></TableCell>
                                                            <TableCell data-title="Days"></TableCell>
                                                            <TableCell data-title="Amount" className="Amount_Fields">
                                                                {formatIndianNumber(requests?.Salary_Details?.netSettlement)}
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                );
                                            })()
                                        ) : (
                                            <TableRow>
                                                <TableCell className="text-left" colSpan={4}>No Records</TableCell>
                                            </TableRow>
                                        )}

                                    </TableBody>
                                </Table>
                            </JumboScrollbar>
                            <br />

                            {/* workflow status */}
                            <WorkflowApproverStatus WorkflowName={WorkflowName} partnerId={requests?.Partner_Id?.id} approvalStatus={approvalStatus?.Approve} />
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    )
}

SettlementDocumentApproval.propTypes = {
    openViewRequest: PropTypes.bool,
    setOpenViewRequest: PropTypes.func,
    requests: PropTypes.object,
    approvalStatus: PropTypes.array,
}

export default SettlementDocumentApproval
